import axios from "axios";
import ObjectInputService from "../../../../../../services/ObjectInput";
import { scrollToTop } from "../../../../../../utils";

export async function getIsTempFileSaved(
  id,
  files,
  setUploading,
  url,
  setLocalvalue,
  changeShowErrorToast,
  handleOtherErrors,
  showErrors,
  intervalId
) {
  const handleError = (response) => {
    handleOtherErrors(response);
    if (!showErrors) {
      changeShowErrorToast(true);
    }
    scrollToTop();
  };

  // This request is to confirm the successful upload of the file and the server's recognition of that.
  const confirmFileUpload = async () => {
    try {
      const response = await ObjectInputService.getTempFileConfirmed(id);
      if (response?.result) {
        clearInterval(intervalId);
        setUploading(id, { verifying: false });
      }
      if (response.error) {
        clearInterval(intervalId);
        setLocalvalue();
        handleError(response);
        setUploading(id, { verifying: false });
      }
    } catch (error) {
      console.error(error);
    }
  };

  // start checking the status of file after every second and stoo it after 30 seconds
  const startCheckingTheFile = async () => {
    intervalId = setInterval(() => confirmFileUpload(), 1000); // Pass a reference to the function
    setTimeout(() => {
      clearInterval(intervalId);
    }, 30000);
  };


  const options = {
    headers: {
      "Content-Type": files[0].type,
    },
    onUploadProgress: (progressEvent) => {
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      setUploading(id, 
        { 
          uploadProgress: percentCompleted,
          uploading: true,
        }
      );
      if (percentCompleted === 100) {
        setUploading(id, 
          { 
            uploadProgress: percentCompleted,
            uploading: false,
            verifying: true 
          }
        );
      }
    },
  };

  try {
    const response = await axios.put(url, files[0], options);
    if (response.error) {
      handleError(response);
    } else {
      startCheckingTheFile();
    }
  } catch (error) {
    console.error("Error uploading file:", error);
  }
}
